<template>
  <div class="elevation-2 bg-white">
    <div class="d-flex flex1 justify-space-between align-center flex-row flex-wrap py-6 px-4">
      <BackToEntryPageButton v-if="!isResultSaved" />

      <div class="d-flex align-center flex-row flex-wrap">
        <div
          class="mx-4 font-weight-medium rounded-pill px-6 py-1 light-blue darken-2 text-h6 white--text"
        >
          {{ loanOfficer.firstName }}
          {{ loanOfficer.lastName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackToEntryPageButton from './BackToEntryPageButton.vue';

export default {
  components: { BackToEntryPageButton },
  computed: {
    isResultSaved() {
      return this.$store.getters.isResultSaved;
    },
    loanOfficer() {
      return this.$store.state.loanOfficer.info;
    }
  }
};
</script>

<style scoped>
.bg-white {
  background-color: white;
}
</style>
